import {requestCommon} from '../libs/axios'

export const getVipInfo = (params) => requestCommon.post('/paralegal/vip/getVipInfo', params) // 通过会员id获取详情
